import { render, staticRenderFns } from "./MainClinic.vue?vue&type=template&id=02ec335b&scoped=true&"
import script from "./MainClinic.vue?vue&type=script&lang=js&"
export * from "./MainClinic.vue?vue&type=script&lang=js&"
import style0 from "./MainClinic.vue?vue&type=style&index=0&id=02ec335b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ec335b",
  null
  
)

export default component.exports